export const DepartamentosEnum = {
  CREDITO: 1,
  COMERCIAL: 2,
  OPERACOES: 3,
  FINANCEIRO_CONTROLADORIA: 4,
  COBRANCA: 5,
  GESTAO_RISCOS: 6,
  TECNOLOGIA: 7,
  FORMALIZACAO: 8,
  CADASTROS: 9,
  CONFIGURACOES: 10,
  CLIENTES: 11
};
